import axiosInstance from 'api/axiosInstance'

export const createPlaylist = async (name: string) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/media',
        data: {
            playlist_name: name
        }
    })
    return data
}

export const getPlaylists = async (searchTerm?: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/media/playlist/all',
        params: searchTerm ? { searchTerm } : {}
    })
    return data?.data
}

export const storeCreatorRecentSearch = async (data: {
    query: string
    response: Array<{
        id: string
        name: string
        username: string
        avatar: string
    }>
}) => {
    const { data: response } = await axiosInstance({
        method: 'POST',
        url: '/api/recent-search',
        data
    })

    return response
}

export const getPlaylistFeed = async (params: {
    searchTerm: string
    filter: string
    page: number
    playlistId: string
}) => {
    const { playlistId, ...queryParams } = params

    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/media/${playlistId}`,
        params: queryParams
    })

    return {
        nextCursor:
            params.page < data.meta.last_page ? params.page + 1 : undefined,
        page: {
            data
        },
        meta: data.meta
    }
}

export const addToPlaylist = async (variables: {
    playlistId: string
    itemId: string
    type: 'post' | 'message'
}) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/media/playlist/${variables.playlistId}`,
        data: {
            item_id: variables.itemId,
            type: variables.type
        }
    })

    return data
}
export const getMediaData = async () => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: '/api/media-home'
  })

  return data.data
}
/* export const getMediaData = async (params: { model_id?: string } = {}) => {
  const queryParams = params.model_id ? { searchTerm: params.model_id } : {};
  const { data } = await axiosInstance({
    method: 'GET',
    url: '/api/media-home',
    params: queryParams
  });
  return data.data;
}
 */
/* export const getMediaData = async (params: { model_id: string | null }) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/media-home',
        params: params.model_id ? { searchTerm: params.model_id } : {}
    })
    return data.data
}
 */
export const getMediaAutocomplete = async (params: { searchTerm: string }) => {
    const { data } = await axiosInstance({
        method: 'get',
        url: '/api/autocomplete',
        params
    })
    return data
}

export const getPurchasesFeed = async (queryParams: {
  searchTerm?: string
  filter?: 'photos' | 'videos'
  page: number
  per_page?: number
  model_id?: string | string | null
}) => {
  const { page, ...rest } = queryParams

  // Only send real filters; strip everything else (including undefined)
  const params: Record<string, any> = { page, ...rest }
  if (params.filter !== 'photos' && params.filter !== 'videos') {
    delete params.filter
  }
  if (!params.searchTerm) {
    delete params.searchTerm
  }

  const url = '/api/purchase/purchased-history'
  const { data } = await axiosInstance({ method: 'GET', url, params })

  return {
    nextCursor: page < data.meta.last_page ? page + 1 : undefined,
    page: { data },
    meta: data.meta,
  }
}

export const getWatchedHistoryFeed = async (queryParams: {
    searchTerm: string
    filter: string
    page: number
}) => {
    const { page } = queryParams

    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/history/watched-history',
        params: queryParams
    })
    return {
        nextCursor: page < data.meta.last_page ? page + 1 : undefined,
        page: {
            data
        },
        meta: data.meta
    }
}

export const deleteWatchedHistory = async () => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: '/api/history/watched'
    })

    return { data }
}
export const deleteSingleWatchedPost = async (postId: string) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/history/watched/${postId}`
    })

    return { data }
}
export const getLikedHistoryFeed = async (params: {
    searchTerm: string
    filter: string
    page: number
}) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/like/liked-history',
        params
    })

    return {
        nextCursor:
            params.page < data.meta.last_page ? params.page + 1 : undefined,
        page: {
            data
        },
        meta: data.meta
    }
}
